<template>
  <div>
    <div class="body-2 d-block d-md-none">
      <VCard elevation="1" class="pa-5 d-flex justify-start align-center">
        <RouterLink :to="companyLink">
          <CompanyLogo :logo="company.logo" :title="company.name" />
        </RouterLink>
        <div class="ml-5">
          <div>
            <div v-if="company.addresses.length > 0">
              {{ company.addresses[0].city }}
            </div>
            <div v-else />
          </div>
          <div>
            <CompanySite v-if="company.site" :url="company.site" class="text-center mt-4" />
            <div v-else />
          </div>
        </div>
      </VCard>
      <VTabs v-show="showTabs" background-color="transparent" class="mt-2 px-2 company-tabs">
        <VTab :ripple="false" :to="companyLink" class="body-2 mr-6">
          {{ $t('about') }}
        </VTab>
        <VTab :ripple="false" :to="vacanciesLink" class="body-2">
          {{ $t('vacancies') }}
          <span v-if="vacancies.isFetched" class="grey--text text--darken-1 pl-1">
            ({{ vacancyVisibilityAllLength }})
          </span>
          <span v-else />
        </VTab>
      </VTabs>
    </div>
    <VCard elevation="1" class="body-2 d-none d-md-block">
      <div class="pa-5">
        <div class="d-flex justify-center align-center">
          <RouterLink :to="companyLink">
            <CompanyLogo :logo="company.logo" :title="company.name" />
          </RouterLink>
        </div>
        <template>
          <div v-if="company.addresses.length > 0">
            {{ company.addresses[0].city }}
          </div>
          <div v-else />
          <CompanySite v-if="company.site" :url="company.site" class="text-center mt-4" />
          <div v-else />
        </template>
      </div>
      <template>
        <VDivider />
        <RouterLink
          :to="companyLink"
          class="pl-5 pr-1 py-3 d-flex justify-space-between align-center cursor-pointer"
        >
          <span>{{ $t('about') }}</span>
          <VIcon color="rgba(10, 130, 217, 0.5)">
            {{ chevron }}
          </VIcon>
        </RouterLink>
        <VDivider />
        <RouterLink
          :to="vacanciesLink"
          class="pl-5 pr-1 py-3 d-flex justify-space-between align-center text-decoration-none"
        >
          <span>
            <span class="text-decoration-underline">{{ $t('vacancies') }}</span>
            <span v-if="vacancies.isFetched" class="grey--text text--darken-1">
              ({{ vacancyVisibilityAllLength }})
            </span>
            <span v-else />
          </span>
          <VIcon color="rgba(10, 130, 217, 0.5)">
            {{ chevron }}
          </VIcon>
        </RouterLink>
      </template>
    </VCard>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mdiChevronRight } from '@mdi/js';
import CompanyLogo from './CompanyLogo.vue';
import CompanySite from './CompanySite.vue';
import { vacancyVisibility } from '../../enums';

export default {
  name: 'CompanySmallCard',
  components: {
    CompanyLogo,
    CompanySite,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    showTabs: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chevron: mdiChevronRight,
    };
  },
  computed: {
    ...mapState('company', ['vacancies']),
    companyLink() {
      if (this.$route?.query?.preview === 'true') {
        return {
          name: 'company',
          params: { companyId: this.company.id },
          query: { preview: 'true' },
        };
      }
      return {
        name: 'company',
        params: { companyId: this.company.id },
      };
    },
    vacanciesLink() {
      if (this.$route?.query?.preview === 'true') {
        return {
          name: 'vacancies',
          params: { companyId: this.company.id },
          query: { preview: 'true' },
        };
      }
      return {
        name: 'vacancies',
        params: { companyId: this.company.id },
      };
    },
    vacancyVisibilityAllLength() {
      return this.vacancies.items.filter(vacancy => vacancy.visibility !== vacancyVisibility.INVITATION).length;
    },
  },
};
</script>
<style lang="scss" scoped>
.company-tabs {
  &::v-deep {
    .v-tabs-bar {
      margin-bottom: 0;
    }
  }
  a {
    color: map-get($material-light, 'text-color');
  }
}

.router-link-exact-active {
  color: map-get($material-light, 'text-color');
  text-decoration: none;

  .text-decoration-underline {
    text-decoration: none !important;
  }
}
</style>

<i18n locale="en" lang="yaml">
  about: About company
  vacancies: Jobs
</i18n>

<i18n locale="ru" lang="yaml">
  about: О компании
  vacancies: Вакансии
</i18n>
